import React from 'react';
import { RouteComponentProps, withRouter } from 'react-router';

import { AuthenticationTabs, EnterpriseConnectionsForm } from '../../../components';
import { Preloader, ToDashboardError } from '../../../components/ui';
import { useCurrentProject } from '../../../contexts/settings';
import { RouteParams } from '../../../routes/types';

const EnterpriseConnections = ({ match }: RouteComponentProps): JSX.Element => {
  const { projectId } = match.params as RouteParams;
  const { currentProjectFetching, error } = useCurrentProject(projectId);

  if (currentProjectFetching) {
    return (
      <AuthenticationTabs>
        <Preloader />
      </AuthenticationTabs>
    );
  }

  if (error) {
    return <ToDashboardError error={error} pageName="enterprise-connections_open" />;
  }

  return (
    <AuthenticationTabs>
      <EnterpriseConnectionsForm projectId={projectId} />
    </AuthenticationTabs>
  );
};

export default withRouter(EnterpriseConnections);
